import * as React from 'react';
export function fillRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else if (typeof ref === 'object' && ref && 'current' in ref) {
        ref.current = node;
    }
}
export function composeRef(...refs) {
    return (node) => {
        refs.forEach(ref => {
            fillRef(ref, node);
        });
    };
}
export function usePrevious(value) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
